import { PublishersSettings } from './publishers-settings';

export { PublishersSettings };
